import { render, staticRenderFns } from "./addSurvey.vue?vue&type=template&id=a3a08cb8&lang=pug"
import script from "./addSurvey.vue?vue&type=script&lang=js"
export * from "./addSurvey.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports